import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ConfigDebtService} from "../../../core/e-commerce/_services";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from "@angular/material";
import {HttpClient} from "@angular/common/http";
import {AuthNoticeService} from "../../../core/auth";
import {CampaignService} from "../../../core/services/campaign.service";
import {ConfigLogisticComponent} from "../../pages/config-logistic/config-logistic.component";
import {ConfigLogisticService} from "../../../core/services/config-logistic.service";
import {ConfigLogistic} from "../../../core/models/config-logistic.model";

@Component({
  selector: 'kt-dialog-config-logistic',
  templateUrl: './dialog-config-logistic.component.html',
  styleUrls: ['./dialog-config-logistic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfigLogisticComponent implements OnInit {

    detailForm: FormGroup;
    error: boolean = false;
    isLoadingResults = false;
    campaigns;

    constructor(
        private configDebtService: ConfigDebtService,
        private _snackBar: MatSnackBar,
        private http: HttpClient,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogConfigLogisticComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private fb: FormBuilder,
        private authNoticeService: AuthNoticeService,
        private campaignService: CampaignService,
        private configLogisticService: ConfigLogisticService
    ) {
    }

  ngOnInit() {
      this.authNoticeService.setNotice(null);
      this.campaignService.getCampaigns().subscribe(res => {
          this.campaigns = res;
      });
      this.initForms();
  }
  initForms() {
      let model;
      if (this.data) {
          model = this.data;
          // model.campaignId = this.data.campaignId;
          model.zones = model.levelIds.toString();
          model.items = this.data.quantityItmsNotCategorized;
      } else {
          model = {};
      }
      this.detailForm = this.fb.group({
          campaignId: [model.campaignId, Validators.required],
          zones: [model.zones, Validators.required],
          items: [model.items, Validators.required],
      });
    }
    saveOrderEvent() {
        const controls = this.detailForm.controls;
        if (this.detailForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                    controls[controlName].markAsTouched();
                }
            );
            return;
        }

        if (this.data == null) {
            this.detailForm.value.zones = this.detailForm.value.zones.replace(/\s/g,'');
            this.detailForm.value.zones = this.detailForm.value.zones.split(',');
            let logistic = new ConfigLogistic();
            logistic.quantityItmsNotCategorized = this.detailForm.value.items;
            logistic.levelIds = this.detailForm.value.zones;
            logistic.campaignId = this.detailForm.value.campaignId;
            this.configLogisticService.createLogisticConfig(logistic).subscribe(resp => {
                    this.dialogRef.close(true);
                    this.cdr.detectChanges();
                },
                error => {
                    let message = 'Ha ocurrido un error';
                    if (error.error === 'Duplicate entry') {
                        message = 'Ya existe una configuración para esta fecha';
                    }
					else if (error.error === "Una de las zonas especificadas no existe en el sistema.") {
						message = error.error;
					}
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        } else {
            this.detailForm.value.zones = this.detailForm.value.zones.replace(/\s/g,'');
            this.detailForm.value.zones = this.detailForm.value.zones.split(',');
            let logistic = new ConfigLogistic();
            logistic.quantityItmsNotCategorized = this.detailForm.value.items;
            logistic.levelIds = this.detailForm.value.zones;
            logistic.campaignId = this.detailForm.value.campaignId;
            logistic.id = this.data.id;
            this.configLogisticService.updateLogisticConfig(logistic).subscribe(() => {
                    this.dialogRef.close(true);
                },
                error => {
                    let message = 'Ha ocurrido un error';
					if (error.error === "Una de las zonas especificadas no existe en el sistema.") {
						message = error.error;
					}
                    this._snackBar.open(message, 'OK', {
                        duration: 3000,
                    });
                });
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.detailForm.controls[controlName];
        if (!control) {
            return false;
        }

        return control.hasError(validationType) && (control.dirty || control.touched);
    }
}
